var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverviewDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ljm3qor6za)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 12a9 9 0 1 1-9-9 9.01 9.01 0 0 1 9 9zm1 0a10 10 0 1 0-20 0 10 10 0 0 0 20 0zm-6.813.313a.499.499 0 0 0-.707 0l-1.98 1.98V8.5a.5.5 0 0 0-1 0v5.793l-1.98-1.98a.501.501 0 1 0-.707.707l2.833 2.834a.5.5 0 0 0 .707 0l2.834-2.834a.5.5 0 0 0 0-.707z",
    fill: "#383634"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ljm3qor6za"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 2)",
    d: "M0 0h20v20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewDownloadIcon);
export default __webpack_public_path__ + "static/media/overview_download_icon.b25afb263e1015772d9692a4c4a88448.svg";
export { ForwardRef as ReactComponent };